import { IStoreState } from "../../../../reducers/types";

export const getDeclineAllFintechOptions = (store: IStoreState) =>
  store.flightShop.declineAllFintechOptions;
